import React from 'react'
import { renderIcon } from '@opallabs/kuiper'
import * as styles from './styles'

export const FacebookFooter: React.FC = () => {
  return (
    <div css={styles.footerWrapper}>
      <ul css={styles.footer}>
        <li css={styles.footerItem}>
          {renderIcon('facebook-mobile-like-outlined', {
            ariaMode: 'hidden',
            className: 'like-icon',
            height: 18,
            width: 18,
          })}
          Like
        </li>
        <li css={styles.footerItem}>
          {renderIcon('facebook-mobile-comment-outlined', {
            ariaMode: 'hidden',
            className: 'comment-icon',
            height: 18,
            width: 18,
          })}
          Comment
        </li>
        <li css={styles.footerItem}>
          {renderIcon('facebook-mobile-share-outlined', {
            ariaMode: 'hidden',
            className: 'share-icon',
            height: 18,
            width: 18,
          })}
          Share
        </li>
      </ul>
    </div>
  )
}
